import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { CanalMidiaSocialPipeModule } from '../../pipes';

import { CanalMidiaSocialInputGroupComponent } from './canal-midia-social-input-group.component';

@NgModule({
    imports: [
        SharedModule,
        CanalMidiaSocialPipeModule
    ],
    declarations: [
        CanalMidiaSocialInputGroupComponent
    ],
    exports: [
        CanalMidiaSocialInputGroupComponent
    ]
})
export class CanalMidiaSocialInputGroupModule { }
